import React from "react";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import useSignOut from "react-auth-kit/hooks/useSignOut";
import axios from "axios";

const SecureComponent = () => {
  // api endpoint
  const signOutApi = process.env.REACT_APP_API_URL + "/api/signout";
  const signOut = useSignOut();
  const authUser = useAuthUser();

  const signOutAction = async () => {
    try {
      // Call the logout API before clearing local state
      await axios.get(signOutApi);
    } catch (error) {
      console.error("Error Logging out:", error);
      // Continue with logout even if API call fails
    }

    // Clear authentication state
    signOut();

    // Force a page reload to ensure clean state
    window.location.href = "/sign-in";
  };

  // console.log(authUser);

  return (
    <div>
      <p>{`Hello ${authUser.name}, your U-ID is: ${authUser.uid}`}</p>
      <button onClick={signOutAction}>Sign Out!</button>
    </div>
  );
};

export default SecureComponent;
